// extracted by mini-css-extract-plugin
module.exports = {"connectPoint":"ConnectPointsWrapper_connectPoint__3m1oD","arrowAcceptElement":"ConnectPointsWrapper_arrowAcceptElement__3SjnB"};